
namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass('Matrix.Dashboards.TableWidgetDesigner')
    export class TableWidgetDesigner implements IWidgetDesigner {
        private dialog: IWidgetDesignerDialog;

        private get columnList() {
            return this.dialog.getEditor("ColumnList", TableColumnListEditor);
        }

        init(dialog: IWidgetDesignerDialog) {
            this.dialog = dialog;

            this.columnList.updateColumns = () => this.updateColumns(true);
            this.dialog.getDatasetEditor().changeSelect2(() => this.updateColumns(false));
        }

        updateColumns(merge: boolean) {
            this.dialog?.getDatasetColumns(columns => this.columnList.setValue(
                columns.filter(x => x.Name && !Q.endsWith(x.Name, "_format_")), merge));
        }

        destroy() {
            this.dialog = null;
        }
    }
}